import React from 'react';
import { motion } from 'motion/react';
import ParticleBackground from './common/ParticleBackground';
import './NetworkGate.css';

export default function NetworkGate({ onSelect }) {
  const handleOnlinePlay = () => {
    onSelect('online');
  };

  return (
    <div className="network-gate">
      <ParticleBackground />

      <div className="gate-content">
        <motion.div 
          className="gate-hero-logo"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ 
            opacity: 1, 
            scale: [1, 1.03, 1],
            y: [0, -10, 0]
          }}
          transition={{ 
            opacity: { duration: 0.8 },
            scale: { duration: 4, repeat: Infinity, ease: "easeInOut" },
            y: { duration: 6, repeat: Infinity, ease: "easeInOut" }
          }}
        >
          <img src="/assets/resources/The-Game-Vault.svg" alt="The Game Vault" className="gate-main-logo" />
        </motion.div>
        
        <motion.div 
          className="gate-card"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <p className="gate-subtitle">Select Connection Mode</p>
          
          <div className="gate-options-grid">
            <motion.button 
              className="gate-tile" 
              onClick={() => onSelect('local')}
              whileHover={{ y: -5, borderColor: "#fcd34d", backgroundColor: "rgba(251, 191, 36, 0.05)" }}
              whileTap={{ scale: 0.98 }}
            >
              <div className="tile-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="neon-svg">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                  <polyline points="9 22 9 12 15 12 15 22"></polyline>
                </svg>
              </div>
              <div className="tile-text">
                <strong>Local Play</strong>
                <span>Play With Bots</span>
              </div>
              <div className="tile-scanline" />
            </motion.button>

            <motion.button 
              className="gate-tile" 
              onClick={handleOnlinePlay}
              whileHover={{ y: -5, borderColor: "#10b981", backgroundColor: "rgba(16, 185, 129, 0.05)" }}
              whileTap={{ scale: 0.98 }}
            >
              <div className="tile-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="neon-svg online">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="2" y1="12" x2="22" y2="12"></line>
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                </svg>
              </div>
              <div className="tile-text">
                <strong>Online Play</strong>
                <span>Play With Friends</span>
              </div>
              <div className="tile-scanline" />
            </motion.button>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
